import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const Alimentation = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Alimentação'}
            horizontal={true}
            subtitles={chartData?.alimentation?.map((item) => item.description)}
            values={chartData?.alimentation?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
